import PropTypes from 'prop-types';
import GoFetch from '~/js/modules/fetch-wrapper';
import ReactLoader from '~/js/components/ReactLoader';
import CreateWishList from './CreateWishList';
import WishListItem from './WishListItem';

const fetch = new GoFetch();

export default class WishListAdmin extends React.PureComponent {
    static propTypes = {
        isAddItem: PropTypes.bool,
        itemDetails: PropTypes.object,
        isAddedOnSignUp: PropTypes.bool,
        isSuccessAddedHandler: PropTypes.func,
        modalUpdateHandler: PropTypes.func,
        updateAccountInfo: PropTypes.func,
        getModifiedWishList: PropTypes.func,
        hasCreateWishlist: PropTypes.bool,
        fromWishlistCollage: PropTypes.bool,
        userWishlists: PropTypes.array,
        shouldLogIn: PropTypes.bool
    };
    static defaultProps = {
        isAddItem: false,
        itemDetails: {},
        updateAccountInfo: () => null,
        modalUpdateHandler: () => null,
        isSuccessAddedHandler: () => null,
        getModifiedWishList: () => null,
        hasCreateWishlist: true,
        fromWishlistCollage: false,
        userWishlists: [],
        shouldLogIn: true
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!nextProps.fromWishlistCollage || nextProps.shouldLogIn) {
            return null;
        }

        return (nextProps.userWishlists === prevState.wishLists)
            ? {}
            : {wishLists: nextProps.userWishlists, isLoaderActive: false};
    }

    constructor() {
        super();
        this.state = {
            wishLists: [],
            accountInfo: {},
            isLoaderActive: true
        };
        this.myRef = React.createRef();
    }

    componentDidMount() {
        if (this.myRef.current && (!this.props.fromWishlistCollage || this.props.shouldLogIn)) {
            this._fetchUserInfo();
            this._fetcWishListData();
        }
    }
    componentDidUpdate(prevState, nextState) {
        if (prevState.accountInfo !== nextState.accountInfo) {
            this.props.updateAccountInfo(this.state.accountInfo);
        }
    }
    _fetchUserInfo = () => {
        fetch.post('/wedding/account/data/')
            .then((resp) => this.setState({accountInfo: resp.data.accountInfo}))
            .catch((err) => console.warn(err));
    };
    _fetcWishListData = () => {
        fetch.post('/getWishLists/')
            .then((resp) => {
                this.setState({
                    wishLists: resp.data.wishLists,
                    isLoaderActive: false
                });
            })
            .catch((err) => console.warn(err));
    };
    _updateWishListToDisplay = (data) => {
        this.setState({ wishLists: data });
    };

    _triggerLoader = (isLoaderActive = false) => this.setState({ isLoaderActive })

    _renderWLItems = (items) => items.map(item => {
        return (<WishListItem
                    key={ item.id }
                    wishListData={item}
                    itemDetails={this.props.itemDetails}
                    updateWishListHandler = { this._updateWishListToDisplay }
                    isAddItem={this.props.isAddItem}
                    userId={this.state.accountInfo.id}
                    isSuccessAddedHandler={this.props.isSuccessAddedHandler}
                    modalUpdateHandler={this.props.modalUpdateHandler}
                    getModifiedWishList={this.props.getModifiedWishList}
                />);
    });

    render() {
        const {isAddItem, hasCreateWishlist} = this.props;
        const WlItems = this._renderWLItems(this.state.wishLists);
        const header = (this.props.fromWishlistCollage) ? (<h3 className="col-xs-12 instructions">select wishlist</h3>) : (<h3 className="col-xs-12 col-sm-6 col-sm-offset-3 instructions">{`${isAddItem ? 'Select wishlist' : 'Select wishlist to View details'}`}</h3>);

        return(
            <div ref={this.myRef} className="row wishlist-admin">
                {
                    header
                }
                {
                    hasCreateWishlist && <CreateWishList accountInfo={ this.state.accountInfo } updateWishListHandler={ this._updateWishListToDisplay } triggerLoader={ this._triggerLoader } />
                }
                <div className="col-xs-12 items-wrapper">
                    {
                        this.state.isLoaderActive && <ReactLoader className={'sk-loader-admin'}/>
                    }
                    <div className="item-list">
                        { (WlItems.length > 0) ? (WlItems) :
                            (<div className="no-wishlist">
                                <h4 className="message">you have no wishlists saved {this.state.accountInfo.id}</h4>
                             </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}
